export enum TipoPerfil {
  ADM = 'ADMINISTRADOR',
  SEECT = 'SEECT',
  RH = 'RH',
  SERV = 'SERVIDOR',
  CHEFE_IMEDIATO = 'CHEFE IMEDIATO',
  SGCONP = 'SGCONP',
}
